/**
 * Pointer Event setup.
 * Load Pointer Event polyfill on browsers without native support.
 * 
 * This needs to run in highest priority (not within DOM ready or async)
 */
export default () => {
  if (!window.PointerEvent) {
    import('pepjs');
  }
};